import { useEffect } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { parse } from 'query-string'
import { batch, useDispatch } from 'react-redux'
import { DashboardInfoTypes, DashboardTypes } from 'features/Codes'
import { setType } from 'features/dashboard/dashboardCommonSlice'
import { setFilters } from 'features/dashboard/filter/dashboardFilterSlice'
import { setInfo } from 'features/dashboard/info/dashboardInfoSlice'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'
import { dashboardTreeActions } from 'features/dashboard/tree/dashboardTreeSlice'
import { TREE_SORT, TREE_STATUS } from 'features/dashboard/tree/StatusAndSort'
import { reset as dashboardChartReset } from 'features/dashboard/info/chart/dashboardChartSlice'
import FullPageLoading from 'components/loading/FullPageLoading'

const DashboardRedirect = () => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const { search } = useLocation()
  const history = useHistory()
  const { campaignId, adGroupId, type } = parse(search)

  useEffect(() => {
    batch(() => {
      dispatch(dashboardChartReset())
      dispatch(setFilters([]))
      dispatch(dashboardTreeActions.setStatus(TREE_STATUS.ALL))
      dispatch(dashboardTreeActions.setSort(TREE_SORT.NAME_ASC))
      dispatch(campaignTableActions.setPage(0))
      dispatch(adGroupTableActions.setPage(0))
      dispatch(keywordTableActions.setPage(0))
      dispatch(creativeTableActions.setPage(0))
      dispatch(keywordTableActions.setSelectedIds([]))
      dispatch(creativeTableActions.setSelectedIds([]))
      if (type === DashboardTypes.CREATIVE || type === DashboardTypes.KEYWORD) {
        dispatch(setInfo({ type: DashboardInfoTypes.AD_GROUP, id: adGroupId }))
        dispatch(campaignTableActions.setSelectedIds([campaignId]))
        dispatch(adGroupTableActions.setSelectedIds([adGroupId]))
        dispatch(dashboardTreeActions.setAdgroupId(adGroupId))
        if (type === DashboardTypes.KEYWORD) {
          dispatch(setType(DashboardTypes.KEYWORD))
          dispatch(
            keywordTableActions.setSort({
              name: 'text',
              order: 'asc',
            })
          )
        } else {
          dispatch(setType(DashboardTypes.CREATIVE))
          dispatch(
            creativeTableActions.setSort({
              name: 'name',
              order: 'asc',
            })
          )
        }
      } else if (type === DashboardTypes.AD_GROUP) {
        dispatch(setInfo({ type: DashboardInfoTypes.CAMPAIGN, id: campaignId }))
        dispatch(setType(DashboardTypes.AD_GROUP))
        dispatch(campaignTableActions.setSelectedIds([campaignId]))
        dispatch(adGroupTableActions.setSelectedIds([]))
        dispatch(dashboardTreeActions.setCampaignId(campaignId))
        dispatch(
          adGroupTableActions.setSort({
            name: 'name',
            order: 'asc',
          })
        )
      } else if (type === DashboardTypes.CAMPAIGN) {
        dispatch(
          setInfo({ type: DashboardInfoTypes.AD_ACCOUNT, id: adAccountId })
        )
        dispatch(setType(DashboardTypes.CAMPAIGN))
        dispatch(campaignTableActions.setSelectedIds([]))
        dispatch(adGroupTableActions.setSelectedIds([]))
        dispatch(dashboardTreeActions.setCampaignId(null))
        dispatch(
          campaignTableActions.setSort({
            name: 'name',
            order: 'asc',
          })
        )
      }
    })
    history.replace(`/${adAccountId}/dashboard`)
  }, [dispatch, campaignId, adGroupId, type, adAccountId, history])
  return <FullPageLoading />
}
export default DashboardRedirect
